import React, {forwardRef, useCallback, useState} from "react";
import {AutoComplete, Button, ButtonToolbar, Checkbox, DatePicker, Form, Modal} from 'rsuite';
import {addNewUserExperience} from "../../../service/experienceService";
import {experienceModel} from "../../form/models";
import {commonJobTitles} from "../../constants/commonJobTitles";

const startDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);
const endDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);

const AddExperienceModal = (props) => {
    const { open, handleClose, userId } = props;

    const [localState, setLocalState] = useState({userId, isPresent: false});

    const localClose = useCallback((response) => {
        handleClose(response);
        setLocalState({userId, isPresent: false});
    }, [handleClose, userId]);

    const submitExperienceAdd = useCallback((isFormValid) => {
        if(!isFormValid) return;
        addNewUserExperience(localState).then((response) => {
            localClose(response);
        });
    }, [localClose, localState]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        if(event.isPresent === true) {
            event.endDate = new Date();
        }
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={localClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Add Experience</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body>
            <Form
                layout="horizontal"
                model={experienceModel}
                onChange={handleFormChange}
                onSubmit={submitExperienceAdd}
                formValue={localState}
            >
                <Form.Group>
                    <Form.ControlLabel>Position</Form.ControlLabel>
                    <Form.Control name="position"
                                  accepter={AutoComplete}
                                  data={commonJobTitles}
                                  style={{width: 300}}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Company</Form.ControlLabel>
                    <Form.Control name="company"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Start Date</Form.ControlLabel>
                    <Form.Control name="startDate" accepter={startDateInstance} />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>EndDate</Form.ControlLabel>
                    <Form.Control
                        name="endDate"
                        accepter={endDateInstance}
                        disabled={localState.isPresent}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Present</Form.ControlLabel>
                    <Form.Control name="isPresent"
                                  accepter={Checkbox}
                                  checked={localState.isPresent}
                                  value={!localState.isPresent}/>
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={localClose} appearance="default">
                            Cancel
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
}

export default AddExperienceModal;